export default {"src":"/_next/static/media/bg-desktop.b245c3a4.svg","height":562,"width":1440,"blurWidth":0,"blurHeight":0};